import React from "react";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Message from "../../components/message/message";
import {showPasswordChange} from '../../store/slices'

const ValidateFirstAccess = () => {
    const dispatch = useDispatch();
    const { userLogged, isFirstAccess, token } = useSelector( state => state.userLogged);
    // const { showPasswordChange } = useSelector( state => state.configuration);
    // const navigate = useNavigate();

    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    const handleClose = () => {
        dispatch(showPasswordChange(true));
    }

    return(
        <Message 
            title={t("validateFirstAccess.title")}
            content={t("validateFirstAccess.content")}
            open={isFirstAccess && userLogged?.role!=='Artista' && token !== null} 
            onClose={()=>handleClose()}
        />
    )
}

export default ValidateFirstAccess;